import { useEffect, useRef, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useStore, useSelector, useDispatch } from 'react-redux'
import { Card, Box, Button, IconButton, Stack, Tooltip, Chip, Alert, Divider, TextField, Avatar } from '@mui/material'
import { newGetList, newPost } from '../../helper/baseFetch_v2'
import MultiLangLabel from '../../Component/common/label/MultiLangLabel'
import MUITable from '../../Component/common/table/MUITable'
import { ListFilter } from '../../Component/ListDisplay/ListFilter'
import Iconify from '../../Component/common/iconify/Iconify'
import { ICONIFY } from '../../Constants/iconify'
import { API_PATH } from '../../Constants/path'
import { Add, WrapText, Delete } from '@mui/icons-material'
import SharedDialog from '../../Component/common/dialog/SharedDialog'
import SurveyPanel from '../../Component/Flow/survey/SurveyPanel'
import SurveyDialog from '../../Component/Flow/survey/SurveyDialog'
import { setSurveyFlow } from '../../actions/surveyFlowAction'
import { constants, MERCHANT_DEVICE_TYPE } from '../../Constants/constants'
import { KEYS_OF_DRAFT_DATA, KEYS_OF_IS_CREATE, KEYS_OF_TEMP_DRAFT_DATA, PREFIX_OF_TEMP_NODE } from '../../Component/Flow/constant'
import StatusLabel from '../../Component/_v2/label/StatusChip'
import { getString, getQuery, getQueryParamObject, getParamQueryString, standardizeOptions, generateTableCellToMultiLanguageName } from '../../helper/util'
import _ from 'lodash'
import { useListParam } from '../../hooks/useListParam'

import { DEVICE_TYPE, chipRender } from './constants'


// survey listing page
export default function AppVersionRestaurantList({
  newPath,
  editBtn = true,
  createBtn = true,
  cloneBtn = true,
  onClickListRow,
  readOnly = false
}) {
  const changeUrlQueryString = true
  const resource = 'appVersionRestaurantPage'
  const filterParams = getQuery()

  const AppVersionListTitleList = [
        {
          key: constants.LIST_DISPLAY_TYPE.STRING,
          value: 'restID',
          sort: true,
        },
        {
          key: constants.LIST_DISPLAY_TYPE.STRING,
          value: 'restName',
          sort: true,
        },
      ]

  const listFilters = [
    {
      className: 'filter-input',
      label: { resource: resource, key: 'restUrlId' },
      clear: true,
      value: '',
      name: 'restUrlId',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'appVersion' },
      clear: true,
      value: '',
      name: 'appVersion',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'buildNumber' },
      clear: true,
      value: '',
      name: 'buildNumber',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'customCode' },
      clear: true,
      value: '',
      name: 'customCode',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'buildTarget' },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: standardizeOptions(constants.CHOICES.APP_VERSION.BUILD_TARGET, 'value', 'name'),
      name: 'buildTarget',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'deviceType' },
      value: '',
      name: 'deviceType',
      size: constants.SIZE.SMALL,
      type: constants.TYPE.SELECT,
      selectValue: standardizeOptions(DEVICE_TYPE, 'value', 'name'),
    }
    // {
    //   className: 'filter-input',
    //   label: { resource: resource, key: 'customCode' },
    //   clear: true,
    //   value: '',
    //   name: 'customCode',
    //   size: constants.SIZE.SMALL,
    // },
    // {
    //   className: 'filter-input',
    //   label: { resource: resource, key: 'buildTarget' },
    //   clear: true,
    //   value: '',
    //   name: 'buildTarget',
    //   size: constants.SIZE.SMALL,
    //   type: constants.TYPE.SELECT,
    //   selectValue: standardizeOptions(constants.CHOICES.APP_VERSION.BUILD_TARGET, 'value', 'name'),
    // },
  ]

  const {
    param,
    setParam,
    onChangeParam,
    onChangeListFilters,
    onChangeListSort,
    onChangeListPage: onChangeListPageParam,
    onChangeListRowsPerPage: onChangeListRowsPerPageParam,
  } = useListParam({
    initialPath: newPath ? newPath : '',
    initialListFilters: _.cloneDeep(listFilters),
    listTitles: AppVersionListTitleList,
    initialSort: 'updateTimestamp',
    initialDirection: 'DESC',
    initialPage: 0,
    initialRowsPerPage: 10,
    changeUrlQueryString,
  })

  const store = useStore()
  const savedSurveyFlow = useSelector(state => state.surveyFlow.ui.surveyFlow)
  const savedSurveyCommonStatus = useSelector(state => state.surveyFlow.ui.common)
  const dispatch = useDispatch()

  const history = useHistory()

  const [list, setList] = useState([])
  const [listLength, setListLength] = useState(0)
  const [listPagination, setListPagination] = useState({
    sort: 'updateTimestamp',
    order: 'DESC',
    pageSize: 10,
    page: 0,
    filter: {},
  })
  const [selected, setSelected] = useState([])
  const [showDialog, setShowDialog] = useState(false)
  const [isCreateMode, setIsCreateMode] = useState(false)

  const lang = useSelector((state) => state.lang.ui.lang)
  const theme = useSelector((state) => state.theme.ui.theme)
  const draftId = useRef(null)

  const columns = useMemo(() => {
    const base = [
      {
        field: 'restUrlId',
        headerName: 'Restaurant ID',
        width: 100,
        flex: 1,
      },
      {
        field: 'restName',
        headerName: 'Restaurant Name',
        width: 600,
        flex: 1,
      }
    ]

    const deviceCols = (list[0]?.deviceTypeList ?? [])
      .map((item) => item.deviceType)
      .map((deviceType) => ({
        field: deviceType,
        headerName: deviceType,
        width: 500,
        flex: 1,
        renderCell: (params) => {
          // find the matching deviceType object on the row
          const deviceObj = (params.row.deviceTypeList || []).find(d => d.deviceType === deviceType) || {}
          const btList = deviceObj.buildTargetList || []
          // show '-' if no build targets
          if (btList.length === 0) return <span>-</span>

          // render one Chip per buildTarget entry (label shows buildTarget and appVersion)
          return (
            <Stack direction="row" spacing={0} sx={{ minWidth: 100, maxWidth: 500, flexWrap: 'wrap' }}>
              {btList.map((bt, i) => {
                const label = `${bt?.appVersion ?? '-'} (${bt?.buildNumber ?? '-'}) ${bt?.customCode ? `+ ${bt.customCode}` : ''}`
                return (
                  <Tooltip key={bt.buildTarget+bt?.appVersion} title={bt?.buildTarget ? getString(lang, '', bt?.buildTarget, theme) : ''} arrow placement='top'>
                    <Chip sx={{margin: '5px'}} icon={<Iconify icon={chipRender(bt.buildTarget).icon} />} color={chipRender(bt.buildTarget).color} label={label} />
                  </Tooltip>
                )
              })}
            </Stack>
          )
        },
      }))

    return [...base, ...deviceCols]
  }, [list])

  const getList = () => {
    let tempParam = _.cloneDeep(param)
    const filter = {}
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value
      }
    })

    const newListPagination = {
      // ...listPagination,
      ...filter,
      // status: 'STABLE',
      // filter: JSON.stringify(filter),
      // androidModern: filter.buildTarget === 'ANDROID_MODERN' ? true : undefined,
      // androidLegacy: filter.buildTarget === 'ANDROID_LEGACY' ? true : undefined,
      // androidMpos: filter.buildTarget === 'ANDROID_MPOS' ? true : undefined,
      // ios: filter.buildTarget === 'IOS' ? true : undefined,
      pageSize: tempParam.rowsPerPage,
      page: tempParam.page,
      sortingList: [
        { sort: 'createDateTime', direction: 'DESC' }
      ]
    }

    // const newListPagination = {
    //   ...filter,
    //   // filter: JSON.stringify(filter),
    //   perPage: tempParam.rowsPerPage,
    //   page: tempParam.page,
    //   sortingList: [
    //     { sort: 'createDateTime', direction: 'DESC' }
    //   ]
    // }

    newGetList({
      path: 'gulu-console/merchant/shop-app-version-control',
      queryObj: newListPagination,
      successCallback: (payload) => {
        const mapped = (payload.list ?? []).map((item) => ({
          ...item,
          restName: generateTableCellToMultiLanguageName(
            item.shop?.name?.['zh-HK'],
            item.shop?.name?.['en'],
            item.shop?.name?.['zh-CN']
          ),
        }))
        setList(mapped)
      },
      store: store,
      getListLength: (listLength) => setListLength(listLength),
    })
  }

  const onClickCreate = (isDelete = false) => {
    if (isDelete) {
      history.push(`/${constants.PATH.APPVERSION_RESTAURANT.APPVERSION_RESTAURANT}/edit/0`)
    } else {
      history.push(`/${constants.PATH.APPVERSION_RESTAURANT.APPVERSION_RESTAURANT}/create/0`)
    }
  }

  const onClickEdit = (id) => {
    history.push(`/${constants.PATH.APPVERSION_RESTAURANT.APPVERSION_RESTAURANT}/` + id)
  }

  const onClickClone = (id) => {

    newPost({
      path: API_PATH.survey.clone,
      body: { sourceId: id },
      successCallback: (payload) => {
        getList()
      },
      store: store,
    })
  }

  function onChangeListPage(e, newPage) {
    setListPagination((prev) => ({ ...prev, page: newPage }))
    onChangeListPageParam(newPage)
  }

  function onChangeListRowsPerPage(e) {
    const rowsPerPage = e?.target?.value
    setListPagination((prev) => ({ ...prev, pageSize: rowsPerPage }))
    onChangeListRowsPerPageParam(rowsPerPage)
  }

  // onChangeParam handled by useListParam

  // URL sync and param initialization handled by useListParam

  function onSaveBulkEdit(data) {
    console.log('data to save', data)
    // setShowDialog(false)
  }

  useEffect(() => {
    getList()
  }, [param.count]) // eslint-disable-line react-hooks/exhaustive-deps

  // keep local pagination state (MUITable) in sync with param (from hook / URL)
  useEffect(() => {
    setListPagination((prev) => ({
      ...prev,
      page: param.page ?? 0,
      pageSize: param.rowsPerPage ?? prev.pageSize,
    }))
  }, [param.page, param.rowsPerPage])

  useEffect(() => {
        // console.log('selected', selected)
    }, [selected])

  return (
    <Card>
      {/* <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}> */}
      <Box sx={{ p: 3 }}>
        {!onClickListRow && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="title">
              App Version Control List
            </div>
            <div>
              {/* <Button startIcon={<Delete />} variant='contained' color='error' onClick={() => onClickCreate(true)}>
                Delete
              </Button> */}
              <Button startIcon={<Add />} sx={{marginLeft: '15px'}} variant='contained' onClick={() => onClickCreate()}>
                Version Control
              </Button>
            </div>
          </Box>
        )}

        <ListFilter onChangeListFilters={onChangeListFilters} listFilters={param.listFilters} />

        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {
              <MUITable
                stickyHeader
                columns={columns}
                rows={list}
                pagination={listPagination}
                setPagination={setListPagination}
                listLength={listLength}
                onClickListRow={onClickListRow}
                handleChangePage={onChangeListPage}
                handleChangeRowsPerPage={onChangeListRowsPerPage}
                // selected={selected}
                // setSelected={setSelected}
              />
          }
          
        </Box>
      </Box>
    </Card>
  )
}